import App from 'app/app.js';

function LtUpperCaseDirective() {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, modelCtrl) {
      modelCtrl.$parsers.push(function (inputValue) {
        if (inputValue === undefined) {
          return '';
        }
        var capitalized = inputValue.toUpperCase();
        if (capitalized !== inputValue) {
          modelCtrl.$setViewValue(capitalized);
          modelCtrl.$render();
        }
        return capitalized;
      });
    }
  };
}

App.directive('ltUpperCase', [LtUpperCaseDirective]);
